import { render, staticRenderFns } from "./CreatFlow.vue?vue&type=template&id=b0102cda&scoped=true&"
import script from "./CreatFlow.vue?vue&type=script&lang=js&"
export * from "./CreatFlow.vue?vue&type=script&lang=js&"
import style0 from "./CreatFlow.vue?vue&type=style&index=0&id=b0102cda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0102cda",
  null
  
)

export default component.exports